import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=fe679270&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe679270')) {
      api.createRecord('fe679270', component.options)
    } else {
      api.reload('fe679270', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=fe679270&", function () {
      api.rerender('fe679270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Cf3Ey87TF7x/JS/comp/ImgFallback.vue"
export default component.exports